let Test = require('@/mixins/Forms/2019/NRCA_LTI_05_A')

module.exports = {

    mixins: [Test],

    data() {
        return {
            functional_test: {
                name: `B-1. Functional Testing by Observation of Systems During Institutional Tuning (NA7.7.5.2.2)`,
                steps: {
                    step_1: {
                        name: `Step 1: Determination of light output or maximum power prior to institutional tuning (NA7.7.5.2.2, Step 1) (Current measurements may be used instead of power measurements to show power reduction.)`,
                        questions: {
                            question_1: {
                                id: `--`,
                                type: 'Option',
                                question: `Select the used measurement Footcandles(<b>fc</b>), Amperes(<b>A</b>) or Watts(<b>W</b>)`,
                                options: [
                                    'fc',
                                    'W',
                                    'A',
                                ],
                                answer: '',
                            },
                            question_2: {
                                id: `a`,
                                type: 'Text',
                                text: `Set all lighting controls to provide maximum output of the tested system without applying the limits specified for institutional tuning. (NA7.7.5.2.2, Step 1(a))`,
                            },
                            question_3: {
                                id: `b`,
                                type: 'Float',
                                question: `Measure the full light output at a location where the illuminance is due to the controlled lighting and enter the value in footcandles (fc). <b>OR</b> Measure the power of the controlled lighting and enter the value in watts (W). (NA7.7.5.2.2, Step 1(b)) (If current measurements are being used, enter the measured current in amperes (A).)`,
                                answer: ''
                            },
                        }
                    },
                    step_2: {
                        name: `Step 2: Institutional tuning and post-tuning measurement (NA7.7.5.2.2, Step 2)`,
                        questions: {
                            question_1: {
                                id: `c`,
                                type: 'Text',
                                text: `Apply the limits specified for institutional tuning to the lighting system. Do not alter any other control settings. (NA7.7.5.2.2, Step 2(a), §140.6(a)2Jiii)`,
                            },
                            question_2: {
                                id: `d`,
                                type: 'Float',
                                question: `Measure the light output at the same location as in Step 1 (line b) and enter the value in footcandles (fc). <b>OR</b> Measure the power of the same circuit as in Step 1 (line b) and enter the value in watts (W). (NA7.7.5.2.2, Step 2(b)) (If current measurements are being used, enter the measured current in amperes (A).)`,
                                answer: ''
                            },
                            question_3: {
                                id: `e`,
                                type: 'Percentage',
                                question: `Calculate ratio of the light or power output of the system after institutional tuning to the light or power output of the system before institutional tuning and enter the value in %. ([line d / line b] x 100)`,
                                answer: ''
                            },
                            question_4: {
                                id: `f`,
                                type: 'BooleanResult',
                                question: `The light output or power after institutional tuning is 85% or less of the light output or power before institutional tuning. (line e <=> 85%) (NA7.7.5.2.2, Step 2(c), Section 140.6(a)2Ji) Enter yes (<b>Y</b>) or no (<b>N</b>).`,
                                answer: ''
                            },
                        }
                    },
                },
                result: false,
                comments: '',
            },
        }
    },

    methods: {

        functionalTestEvaluation() {

            if (!this.testIsReady) return;

            this.form.functional_test.result = true;

            var steps = this.form.functional_test.steps;

            var s1Questions = steps.step_1.questions;
            var s2Questions = steps.step_2.questions;

            if (!!s1Questions.question_1.answer == false) {
                this.form.functional_test.result = false;
            }

            var row_B = s1Questions.question_3.answer;
            var row_D = s2Questions.question_2.answer;

            var row_E = (row_D / row_B)

            if (!this.isValidNumber(row_E)) {
                this.form.functional_test.result = false;
                s2Questions.question_3.answer = 0;
            } else {
                s2Questions.question_3.answer = row_E;
            }

            var row_F = s2Questions.question_4.answer = (row_E >= 0) && (row_E <= .85);

            if (row_F == false) {
                this.form.functional_test.result = false;
            }
        },

    },
}
